import type { ComponentRequirements } from '@vibesites/tokens';
import { defineComponentRequirements } from '@vibesites/tokens';

export const componentRequirements: Record<string, ComponentRequirements> = {
  Header: defineComponentRequirements('Header', {
    tokens: ['color.primary', 'color.text', 'color.background', 'color.border', 'font.heading', 'font.body'],
    fields: ['property_name', 'property_primary_logo', 'property_apply_now_url'],
  } as any),
  Footer: defineComponentRequirements('Footer', {
    tokens: ['color.primary', 'font.heading', 'font.body'],
    fields: ['property_name', 'property_call_tracking_phone', 'property_phone', 'property_full_address'],
  } as any),
  Hero: defineComponentRequirements('Hero', {
    tokens: ['color.primary', 'font.heading', 'font.body'],
    fields: ['property_name', 'property_short_description', 'property_featured_image'],
  } as any),
};

export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
